import React, {useContext, useState, useEffect} from 'react';

import {isSeoRender} from '@/modules/SEO';
import {getFeatureFlags} from '../services/getFeatureFlags';
import {FeatureFlags} from '../types/FeatureFlag';

const FeatureFlagsContext = React.createContext<FeatureFlags>({});

const FeatureFlagsProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
  const [featureFlags, setFeatureFlags] = useState({});

  useEffect(() => {
    if (!isSeoRender) getFeatureFlags().then(setFeatureFlags);
  }, []);

  return <FeatureFlagsContext.Provider value={featureFlags}>{children}</FeatureFlagsContext.Provider>;
};

const useFeatureFlags = () => useContext(FeatureFlagsContext);

export {FeatureFlagsProvider, useFeatureFlags};
